module.exports = __webpack_public_path__ + "assets/chevron-down-bold-eb39a2.svg";